import { Injectable,Injector } from '@angular/core';
import {MatSnackBar} from '@angular/material';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';


@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor { 
    constructor(private snackBar:MatSnackBar){}
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{
      return next.handle(request)
         .pipe(
           catchError( (error: any) => { 
              let errMsg = '';
              console.log("error",error);
              // Client Side Error   
              if (error.error instanceof ErrorEvent) {
                // toaster.changeErrorGlobal('Something bad happened; please try again later.');       
                errMsg = `Error: ${error.error.message}`;
              } 
               else {  // Server Side Error
                errMsg = `Error Code: ${error.status},  Message: ${error.message}`;
              }
              
          
              if(error.error.message){
                this.snackBar.open(error.error.message, '', {
                  duration: 4000,
                  verticalPosition: 'top',
                  panelClass: ['red-snackbar']
                });
              }else if(error.message){
                this.snackBar.open('Something bad happened; please try again later.', '', {
                  duration: 4000,
                  verticalPosition: 'top',
                  panelClass: ['red-snackbar']
                });
              }
            //   this.toastrService.error('Something bad happened; please try again later.');       
              return throwError('Something bad happened; please try again later.');
            })
         )
    }
}
@Injectable()
export class tokenInterceptor implements HttpInterceptor {
intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     set X-Frame-Options "allow-from https://example.com/"
//     // const token: string = '123321';
//     // console.log('token--->>>', token);
//     if (token) {
//         request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
//     }
//     if (!request.headers.has('Content-Type')) {
//         request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
//     }'Content-Type': 'application/json',
//     request = request.clone({ headers: request.headers.set('Accept', 'application/json') });
//    request = request.clone({ headers: request.headers.set('Content-Type', 'application/json') });
    return next.handle(request).pipe(
        map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
                console.log("result",event);
            }
            return event;
        }));
 }
}

//error related interceptor
